"use client";

import { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import BasicTable from "../../../Components/Table/Material";
import useApi from "../../../Hooks/useApi";
import { usePagination } from "../../../Hooks/usePagination";

import { handleApiError } from "../../../Helpers/ErrorHandler";
import Common from "../../../Components/Layouts/Common";
import ButtonToolbar from "../../Shared/ButtonToolbar";
import showToast from "../../../Helpers/toast";
import ConfirmModal from "../../../Components/Modal/ConfirmModal.js";

const ActionButtonPanel = ({ row, onDelete }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <div className="inline-flex flex-wrap gap-2 justify-center text-xs">
      {row.status === "COMPLETED" ? (
        <Link
          to={`/create-kii-questionnaire`}
          state={{
            name: row.name,
            id: row.id,
            isTemplate: true,
          }}
        >
          <button
            className={`bg-[#37a45be6] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
          >
            Use Template
          </button>
        </Link>
      ) : (
        <Link
          to={`/create-kii-questionnaire`}
          state={{ name: row.name, id: row.id }}
        >
          <button
            className={`bg-[#1976d2] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
          >
            Complete Draft
          </button>
        </Link>
      )}

      <Link
        to={"/view-kii-questionnaire"}
        state={{ id: row.id, viewType: "view" }}
      >
        <button
          className={`bg-[#1976d2] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
        >
          View KII Questiuonnaire
        </button>
      </Link>
      <Link /* to={`/mapped-kii`} */>
        <button
          disabled={true}
          className={`disabled:bg-gray-400 disabled:cursor-not-allowed bg-[#1976d2] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
        >
          Mapped KIIs
        </button>
      </Link>

      <button
        // onClick={onDelete}
        onClick={() => {
          setModalOpen(true);
        }}
        className={`bg-red-500 border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
      >
        Delete Questionnaire
      </button>

      <ConfirmModal
        label={
          <p>
            Are you sure,
            <br /> You want to Delete?
          </p>
        }
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        onConfirm={() => {
          onDelete();
          setModalOpen(false);
        }}
      />
    </div>
  );
};

const QuestionnaireList = () => {
  const { request } = useApi();
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize pagination state from router or default values
  // const initialPage = location.state?.page || 0;
  // const initialRowsPerPage = location.state?.rowsPerPage || 10;
  const paginateProps = usePagination();

  const [questionnaireData, setQuestionnaireData] = useState();
  const fetchKiiQuestionnaire = useCallback(async () => {
    try {
      const response = await request(
        "GET",
        `/v1/kii/questionnaires/list?offset=${paginateProps.page}&limit=${paginateProps.rowsPerPage}`,
        {},
        "kii_service"
      );

      setQuestionnaireData(response.content);
      paginateProps.setTotalData(response.totalElements);
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  }, [
    paginateProps.page,
    paginateProps.rowsPerPage,
    request,
    paginateProps.setTotalData,
  ]);

  useEffect(() => {
    fetchKiiQuestionnaire();
  }, [fetchKiiQuestionnaire]);
  // Update router state when pagination changes
  // useEffect(() => {
  //   navigate(location.pathname, {
  //     state: {
  //       ...location.state,
  //       page: paginateProps.page,
  //       rowsPerPage: paginateProps.rowsPerPage,
  //     },
  //     replace: true,
  //   });
  // }, [paginateProps.page, paginateProps.rowsPerPage]);

  const columns = [
    {
      id: "name",
      label: "Questionnaire Title",
      minWidth: 170,
    },
    {
      id: "creationDate",
      label: "Date Created",
      minWidth: 100,
      // renderCell: (row) => {
      //   return new Date(row.creationDate)?.toLocaleDateString();
      // },
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
    },
    {
      id: "action",
      label: "Actions",
      minWidth: 170,
      align: "center",
      renderCell: (row) => {
        return (
          <ActionButtonPanel row={row} onDelete={() => handleDelete(row)} />
        );
      },
    },
  ];

  const handleDelete = async (row) => {
    const questionnaireId = row?.id;

    if (!questionnaireId) return;

    try {
      const response = await request(
        "DELETE",
        `/v1/kii/questionnaires/${questionnaireId}`,
        {},
        "kii_service"
      );
      showToast({ message: response?.message });
      // Fetch updated data after successful deletion
      fetchKiiQuestionnaire();
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <div className=" bg-white  relative h-full">
      <Common headline={"KII Questionnaire List"}>
        {/* <KIIButtonToolbar /> */}
        <ButtonToolbar
          title={"Add New KII Questionnaire"}
          navigateURL={"/select-kii-questionnaire-method"}
        />
        <BasicTable
          columns={columns}
          data={questionnaireData}
          paginateProps={paginateProps}
          maxHeight={15000}
        />
      </Common>
    </div>
  );
};

export default QuestionnaireList;
